module.exports = __webpack_public_path__ + "img/spring_trip-20160416-8.f3e70136.jpg";